import { useState } from 'react';
import {
  SecondaryMenuWrapper,
  StyledToggle,
  HamburgerMenu,
} from './SecondaryNavigationMenu.styles';

interface SecondaryNavigationMenuProps {
  children: React.ReactNode;
}

const SecondaryNavigationMenu = ({ children }: SecondaryNavigationMenuProps) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <StyledToggle>
        <HamburgerMenu
          isActive={isOpen}
          handleOnClick={() => {
            setIsOpen((prev) => !prev);
          }}
        />
      </StyledToggle>
      <SecondaryMenuWrapper isSecondaryNavOpen={isOpen}>{children}</SecondaryMenuWrapper>
    </>
  );
};

export default SecondaryNavigationMenu;
